/* Hundepappa: felles JS for Pawzler-landingssidene.
   1) Legg i handlekurv fra sett-kortene (åpner temaets cart drawer når den finnes).
   2) Klebrig kjøpsknapp på mobil når settene er rullet forbi.
   3) Quiz: ett spørsmål om gangen, resultat med anbefalt sett. */
(function () {
  function money(cents) {
    var kr = Math.round(cents / 100);
    return kr.toLocaleString('nb-NO') + ' kr';
  }

  /* ---------- 1) Legg i handlekurv ---------- */
  function addToCart(btn) {
    var id = btn.getAttribute('data-variant');
    if (!id || btn.disabled) return;
    var label = btn.innerHTML;
    var small = btn.classList.contains('hp-pz__add');
    btn.disabled = true;
    if (small) { btn.classList.add('is-loading'); } else { btn.textContent = 'Legger i kurven'; }

    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    try {
      /* Concept-temaet samler seksjonene draweren trenger via denne hendelsen */
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    } catch (e) { sections = []; }

    var body = { items: [{ id: parseInt(id, 10), quantity: 1 }] };
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status) throw new Error(json.description || 'Feil');
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (!small) btn.textContent = 'Lagt i kurven';
        document.dispatchEvent(new CustomEvent('hp-pz:added', { detail: { variant: parseInt(id, 10) } }));
        var opened = false;
        try {
          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: parseInt(id, 10), cart: json });
          }
          /* Små «Legg til»-knapper åpner ikke draweren, så man kan plukke flere moduler på rad */
          if (small) { opened = true; }
          else if (drawer && typeof drawer.show === 'function') { drawer.show(); opened = true; }
        } catch (e) { opened = false; }
        if (!opened) { window.location.href = '/cart'; return; }
        setTimeout(function () { btn.disabled = false; btn.classList.remove('is-added'); if (!small) btn.innerHTML = label; }, small ? 1600 : 2500);
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (!small) btn.innerHTML = label;
        window.location.href = '/cart/add?id=' + id + '&quantity=1';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pz-add]');
    if (btn) { e.preventDefault(); addToCart(btn); }
  });

  /* Teller i landingsside-toppen */
  document.addEventListener('hp-pz:added', function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var cartLink = document.querySelector('.hp-lp-head__cart');
      if (!cartLink) return;
      var count = cartLink.querySelector('.hp-lp-head__count');
      if (!count) { count = document.createElement('span'); count.className = 'hp-lp-head__count'; cartLink.appendChild(count); }
      count.textContent = c.item_count;
    }).catch(function () {});
  });

  /* ---------- 1b) Bygg din egen: nivåfaner og mengderabatt ---------- */
  var modsWrap = document.querySelector('[data-pz-moduler]');
  if (modsWrap) {
    var tabs = modsWrap.querySelectorAll('.hp-pz__tab');
    var ind = modsWrap.querySelector('.hp-pz__tab-ind');
    var mods = modsWrap.querySelectorAll('.hp-pz__mod');
    function moveInd(tab) {
      if (!ind) return;
      ind.style.width = tab.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + (tab.offsetLeft - 4) + 'px)';
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var lvl = tab.getAttribute('data-pz-tab');
        tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        moveInd(tab);
        mods.forEach(function (m, i) {
          var show = lvl === 'alle' || m.getAttribute('data-pz-lvl') === lvl;
          m.hidden = !show;
          if (show) { m.style.animation = 'none'; void m.offsetWidth; m.style.animation = ''; m.style.animationDelay = Math.min(i, 8) * 30 + 'ms'; }
        });
      });
    });
    var first = modsWrap.querySelector('.hp-pz__tab.is-on');
    if (first) { moveInd(first); if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { moveInd(first); }); }
    window.addEventListener('resize', function () { var t = modsWrap.querySelector('.hp-pz__tab.is-on'); if (t) moveInd(t); });

    /* Mengderabatt: teller Pawzler-moduler i kurven (variant-id-ene ligger på seksjonen) */
    var modIds = (modsWrap.getAttribute('data-pz-modul-ids') || '').split(',').filter(Boolean).map(function (x) { return parseInt(x, 10); });
    var rab = modsWrap.querySelector('[data-pz-rab]');
    function paintRab(count) {
      if (!rab) return;
      var t1 = 6, t2 = 9, t3 = 14;
      var pct = Math.min(100, count / t3 * 100);
      rab.querySelector('[data-pz-rab-fill]').style.width = pct + '%';
      var dots = rab.querySelectorAll('.hp-pz__rab-bar b');
      [t1, t2, t3].forEach(function (t, i) { dots[i].classList.toggle('is-hit', count >= t); });
      var title = rab.querySelector('[data-pz-rab-title]'), sub = rab.querySelector('[data-pz-rab-sub]');
      if (count >= t3) { title.textContent = count + ' moduler i kurven, du sparer 15 %'; sub.textContent = 'Maks rabatt. Trekkes fra i handlekurven.'; }
      else if (count >= t2) { title.textContent = count + ' moduler i kurven, du sparer 8 %'; sub.textContent = 'Legg til ' + (t3 - count) + ' til og spar 15 %.'; }
      else if (count >= t1) { title.textContent = count + ' moduler i kurven, du sparer 5 %'; sub.textContent = 'Legg til ' + (t2 - count) + ' til og spar 8 %.'; }
      else if (count > 0) { title.textContent = count + (count === 1 ? ' modul' : ' moduler') + ' i kurven'; sub.textContent = 'Legg til ' + (t1 - count) + ' til og spar 5 %. 9 gir 8 %, 14 gir 15 %.'; }
      else { title.textContent = 'Mengderabatt på moduler'; sub.textContent = '6 moduler gir 5 %, 9 gir 8 %, 14 gir 15 %. Trekkes fra i handlekurven.'; }
    }
    function countFromCart(cart) {
      var n = 0;
      (cart && cart.items || []).forEach(function (it) { if (modIds.indexOf(it.variant_id) > -1) n += it.quantity; });
      return n;
    }
    function refreshRab() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { paintRab(countFromCart(c)); }).catch(function () {});
    }
    refreshRab();
    document.addEventListener('hp-pz:added', function (e) { if (e.detail && e.detail.cart && e.detail.cart.items) paintRab(countFromCart(e.detail.cart)); else refreshRab(); });
    if (window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS) {
      try { theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () { refreshRab(); }); } catch (e) {}
    }
  }

  /* ---------- 2) Klebrig CTA på mobil ---------- */
  var sticky = document.querySelector('[data-pz-sticky]');
  if (sticky) {
    var target = document.querySelector(sticky.getAttribute('data-pz-sticky') || '#pz-sett');
    var showAfter = document.querySelector('[data-pz-sticky-after]');
    var stickyOn = function (on) {
      sticky.classList.toggle('is-on', on);
      document.body.classList.toggle('hp-pz-sticky-on', on);
    };
    if (showAfter && 'IntersectionObserver' in window) {
      var passed = false, inTarget = false;
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { passed = !en.isIntersecting && en.boundingClientRect.top < 0; stickyOn(passed && !inTarget); });
      }, { threshold: 0 }).observe(showAfter);
      /* Skjul den klebrige knappen mens settene eller quizresultatet (som har egen kjøpsknapp) er synlig */
      var seen = {};
      var hideWhile = [target, document.querySelector('.hp-pz__res'), document.querySelector('[data-pz-moduler]')].filter(Boolean);
      if (hideWhile.length) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) { seen[en.target.className] = en.isIntersecting; });
          inTarget = Object.keys(seen).some(function (k) { return seen[k]; });
          stickyOn(passed && !inTarget);
        }, { threshold: 0.1 });
        hideWhile.forEach(function (el) { io.observe(el); });
      }
    }
    var link = sticky.querySelector('a[href^="#"]');
    if (link) link.addEventListener('click', function (e) {
      var t = document.querySelector(link.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }

  /* ---------- 3) Quiz ---------- */
  var quiz = document.querySelector('[data-pz-quiz]');
  if (!quiz) return;

  var qs = Array.prototype.slice.call(quiz.querySelectorAll('.hp-pz__q'));
  var prog = quiz.querySelector('.hp-pz__qprog i');
  var count = quiz.querySelector('.hp-pz__qcount');
  var back = quiz.querySelector('.hp-pz__qback');
  var res = quiz.querySelector('.hp-pz__res');
  var intro = document.querySelector('[data-pz-quiz-intro]');
  var answers = [];
  var idx = 0;
  var startBtn = document.querySelector('[data-pz-quiz-start]');

  function show(i) {
    idx = i;
    qs.forEach(function (q, n) { q.classList.toggle('is-on', n === i); });
    if (prog) prog.style.width = ((i) / qs.length * 100) + '%';
    if (count) count.textContent = 'Spørsmål ' + (i + 1) + ' av ' + qs.length;
    if (back) back.hidden = i === 0;
  }

  function finish() {
    var score = 0, wish = 'ro';
    answers.forEach(function (a, n) {
      if (a.score !== undefined) score += a.score;
      if (a.wish) wish = a.wish;
    });
    var level = score <= 2 ? 1 : score <= 4 ? 2 : 3;
    var data = JSON.parse(quiz.getAttribute('data-pz-results') || '{}');
    var r = data['n' + level] || {};
    var wishes = data.wish || {};

    qs.forEach(function (q) { q.classList.remove('is-on'); });
    if (prog) prog.style.width = '100%';
    if (count) count.textContent = 'Resultat';
    if (back) back.hidden = true;
    quiz.querySelector('.hp-pz__qhead').hidden = true;

    res.querySelector('[data-r-type]').textContent = r.type || '';
    res.querySelector('[data-r-title]').textContent = r.title || '';
    res.querySelector('[data-r-text]').textContent = (r.text || '') + ' ' + (wishes[wish] || '');
    res.querySelector('[data-r-name]').textContent = r.name || '';
    res.querySelector('[data-r-desc]').textContent = r.desc || '';
    res.querySelector('[data-r-meta]').textContent = r.meta || '';
    res.querySelector('[data-r-price]').textContent = money(r.price || 0);
    var cmp = res.querySelector('[data-r-compare]');
    if (cmp) { if (r.compare) { cmp.textContent = money(r.compare); cmp.hidden = false; } else cmp.hidden = true; }
    var save = res.querySelector('[data-r-save]');
    if (save) { if (r.compare && r.price) { save.textContent = 'Spar ' + money(r.compare - r.price); save.hidden = false; } else save.hidden = true; }
    var img = res.querySelector('[data-r-img]');
    if (img && r.image) { img.src = r.image; img.alt = r.name || ''; }
    var add = res.querySelector('[data-r-add]');
    if (add) add.setAttribute('data-variant', r.variant || '');
    var lnk = res.querySelector('[data-r-link]');
    if (lnk && r.url) lnk.href = r.url;
    var why = res.querySelector('[data-r-why]');
    if (why) { why.innerHTML = ''; (r.why || []).forEach(function (w) { var li = document.createElement('li'); li.textContent = w; why.appendChild(li); }); }

    res.classList.add('is-on');
    var pin = res.querySelector('.hp-pz__meter i');
    if (pin) { pin.style.left = '4%'; setTimeout(function () { pin.style.left = (level === 1 ? 16 : level === 2 ? 50 : 86) + '%'; }, 80); }
    res.scrollIntoView({ behavior: 'smooth', block: 'start' });

    try { if (window.dataLayer) window.dataLayer.push({ event: 'pz_quiz_result', level: level }); } catch (e) {}
  }

  quiz.addEventListener('click', function (e) {
    var opt = e.target.closest('.hp-pz__opt');
    if (!opt) return;
    var q = opt.closest('.hp-pz__q');
    q.querySelectorAll('.hp-pz__opt').forEach(function (o) { o.classList.remove('is-picked'); });
    opt.classList.add('is-picked');
    answers[idx] = { score: opt.hasAttribute('data-score') ? parseInt(opt.getAttribute('data-score'), 10) : undefined, wish: opt.getAttribute('data-wish') || undefined };
    setTimeout(function () {
      if (idx < qs.length - 1) show(idx + 1); else finish();
    }, 320);
  });

  if (back) back.addEventListener('click', function () { if (idx > 0) show(idx - 1); });

  if (startBtn) startBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (intro) intro.hidden = true;
    quiz.hidden = false;
    show(0);
    quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  show(0);
})();
